import { RxPerson } from 'react-icons/rx';
import { RiStarSmileFill } from 'react-icons/ri';
import { CgNotes } from 'react-icons/cg';
import { GrContact } from 'react-icons/gr';
import {useState} from "react";

import '../css/AppBar.css'
import React from 'react';

function AppBar() {
  const [activeNav, setActiveNav] = useState('#')
  return (
    <div className="containerAppBar">
      <div className="AppBar">

        <a href="#" className={activeNav === '#' ? 'active' : ''} onClick={() => setActiveNav('#')}> <RxPerson className='icon' color='black'></RxPerson></a>
        <a href="#habilidade" className={activeNav === '#habilidade' ? 'active' : ''} onClick={() => setActiveNav('#habilidade')}><RiStarSmileFill className='icon'></RiStarSmileFill></a>
        <a href="#projetos" className={activeNav === '#projetos' ? 'active' : ''} onClick={() => setActiveNav('#projetos')}><CgNotes className='icon'></CgNotes></a>
        <a href="#contato" className={activeNav === '#contato' ? 'active' : ''} onClick={() => setActiveNav('#contato')}><GrContact className='icon'></GrContact></a>

      </div>
    </div>
  );
}

//RxPerson

export default AppBar;
